import convertToFileDownload from '../../FileDownloads';
import { toast } from 'react-toastify';

const defaultWarningMessage = 'Assignment succeeded, but order document upload failed.';

const handleAssignmentActionResponse = data => {
  const files = data?.files ?? [];
  files
    .filter(f => f?.file && f?.fileName)
    .forEach(f => convertToFileDownload(f.file, f.fileName));

  const documentsUploaded = data?.orderDocumentUploadSucceeded !== false;
  if (!documentsUploaded) {
    toast.warn(data?.orderDocumentUploadErrorMessage || defaultWarningMessage, {
      hideProgressBar: true,
      position: 'top-center',
    });
  }

  return documentsUploaded;
};

export default handleAssignmentActionResponse;
